var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2433 1.06333C10.3409 1.11766 10.4175 1.20312 10.4609 1.30607C10.5043 1.40901 10.5119 1.52353 10.4826 1.63133L9.15464 6.5H14C14.0974 6.5 14.1927 6.52848 14.2742 6.58193C14.3557 6.63538 14.4198 6.71147 14.4586 6.80085C14.4974 6.89022 14.5092 6.989 14.4927 7.08502C14.4761 7.18104 14.4318 7.27013 14.3653 7.34133L7.3653 14.8413C7.28906 14.9232 7.18756 14.9771 7.07705 14.9945C6.96654 15.0119 6.85339 14.9917 6.75571 14.9372C6.65803 14.8826 6.58145 14.7969 6.53823 14.6937C6.49501 14.5906 6.48764 14.4759 6.5173 14.368L7.8453 9.5H2.99997C2.90253 9.49999 2.80721 9.47151 2.72574 9.41806C2.64426 9.36462 2.58018 9.28853 2.54137 9.19915C2.50256 9.10977 2.49071 9.011 2.50728 8.91498C2.52385 8.81895 2.56812 8.72987 2.63464 8.65866L9.63463 1.15866C9.71088 1.07709 9.81223 1.02339 9.92254 1.00611C10.0329 0.988837 10.1458 1.00898 10.2433 1.06333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade);
export default __webpack_public_path__ + "static/media/upgrade.998d231875331dc78f79a79fc07935c7.svg";
export { ForwardRef as ReactComponent };